export default __webpack_public_path__ + "static/media/white-cross.32eb7245.svg";